import { useTheme } from "@/shadcn/components/theme-provider";
import { ChatMessage } from "@/types";
import { format, isToday } from "date-fns";
import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";
import React, { useMemo } from "react";

type MessageBubbleProps = {
  message: ChatMessage;
  isSending?: true;
};

const MessageBubble: React.FC<MessageBubbleProps> = ({
  message,
  isSending,
}) => {
  const { theme } = useTheme();
  const isSender = useMemo(() => message.sender === "user", [message.sender]); // Using useMemo to calculate isSender

  const formattedTimestamp = useMemo(() => {
    const date = new Date(message.timestamp); // Convert epoch time to Date object
    return isToday(date) ? format(date, "HH:mm") : format(date, "MM/dd HH:mm");
  }, [message.timestamp]);

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "fade-in", stiffness: 120, duration: 0.2 }}
      key={message.timestamp + "motion_div"}
      className={`flex my-1 ${isSender ? "justify-end" : "justify-start"}`}
    >
      <div
        className={`max-w-[95%] min-w-36 p-2 break-words rounded-lg ${
          isSender
            ? theme === "dark"
              ? "bg-primary"
              : "bg-primary text-white"
            : theme === "dark"
              ? "bg-secondary"
              : "bg-secondary"
        } `}
      >
        <p className="mb-0 whitespace-pre-wrap">{message.message}</p>
        <div className="flex justify-between items-center gap-2">
          <div>
            {isSender && !isSending && <CheckCheck className="w-4 h-4" />}
          </div>
          <div>{formattedTimestamp}</div>
        </div>
      </div>
    </motion.div>
  );
};

export default MessageBubble;
